// New

import React, { useState, useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/navbar/index.jsx";
import {
  Container,
  Grid,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  TextField,
} from "@mui/material";
import {
  FaHandshake,
  FaSearchDollar,
  FaShieldAlt,
  FaChartLine,
} from "react-icons/fa";
import { motion } from "framer-motion";
import startupImage from "../../assets/images/carousel_one/startup.jpg";
import businessVideo from "../../assets/videos/business.mp4";
import { useNavigate } from "react-router-dom";
import { buysellForm } from "../../components/Api/Api.jsx";

export default function BuySell() {
    const navigate = useNavigate();
  
  const features = [
    {
      icon: <FaSearchDollar size={48} color="#2DBA70" />,
      title: "Vast Industry Network",
      description:
        "Access a curated pool of serious buyers and sellers through our extensive network.",
    },
    {
      icon: <FaShieldAlt size={48} color="#2DBA70" />,
      title: "Confidential Transactions",
      description:
        "Your business information remains private and protected throughout the process.",
    },
    {
      icon: <FaChartLine size={48} color="#2DBA70" />,
      title: "End-to-End Assistance",
      description:
        "From valuation to closing, we manage the entire process for a seamless experience.",
    },
  ];

  const processSteps = [
    {
      title: "High Cost Of Treatment",
      description:
        "Medical emergencies come without a warning. At times, health insurance and savings are not enough to cover the expensive bill. Crowdfunding helps you reach your goal by getting small donations from a large group of people.",
    },
    {
      title: "Asking For Money Isn’t Easy",
      description:
        "When in need, asking for help from people and describing financial problems face-to-face can be awkward and inconvenient. Online crowdfunding makes the process of asking for money easier and way more seamless.",
    },
    {
      title: "Emergencies Demand A Prompt Response",
      description:
        "When your loved ones are diagnosed with life-threatening diseases, it’s overwhelming emotionally as well as financially. Most medical emergencies require the treatment to start at the earliest. By giving you a platform to share your emergency, online crowdfunding helps you gather funds quickly.",
    },
    {
      title: "Loan Repayment Is Stressful",
      description:
        "Getting drowned in personal loans is very common in times of medical emergencies. Once the money is gathered, repaying that loan may take months, sometimes years together. Online crowdfunding comes without debts.",
    },
  ];

  const handleFormSubmit = (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const dataToSubmit = {};

    formData.forEach((value, key) => {
      dataToSubmit[key] = value;
    });

    fetch(`${buysellForm}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(dataToSubmit),
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        if (res.success) {
          navigate("/thank-you");
        } else {
          alert("Error submitting form. Please try again.");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("Failed to submit form. Please check your network connection.");
      });
  };

  return (
    <>
      <Navbar />

      {/* Hero Section */}

      <div className="main-banner">
        <video autoPlay loop muted playsInline className="banner-video">
          <source src={businessVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="banner-content">
          <Typography
            style={{
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "38px",
            }}
          >
            Seamless Business Transactions
          </Typography>
          <p style={{ fontSize: "20px" }}>
            Whether you’re looking to sell your business or acquire a new one,
            AQT Direct provides expert guidance at every step. Our structured
            approach ensures smooth transactions, secure negotiations, and
            maximum value for both buyers and sellers.{" "}
            {/* <span className="break-after">financial</span> solutions designed to
             meet your business needs. */}
          </p>
        </div>
      </div>

      {/* <Box sx={{ 
        position: 'relative',
        height: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        mb: 8
      }}>
        <Box sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1
        }} />
        <Box
          component="img"
          src={startupImage}
          alt="Business transaction"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
        <Container sx={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
          <Typography variant="h2" component="h1" sx={{ 
            fontWeight: 700,
            mb: 3,
            fontSize: '34px'
          }}>
            Seamless Business Transactions
          </Typography>
          <Typography variant="h5" sx={{ 
            mb: 4,
            fontSize: '16px'
          }}>
Whether you’re looking to sell your business or acquire a new one, AQT Direct provides expert guidance at every step. Our structured approach ensures smooth transactions, secure negotiations, and maximum value for both buyers and sellers.


          </Typography>
         
        </Container>
      </Box> */}

      {/* Process Section */}
      <Box
        sx={{
          py: 8,
          backgroundColor: "#f9f9f9",
        }}
      >
        <Container>
          <Typography
            variant="h4"
            component="h2"
            sx={{
              textAlign: "center",
              fontWeight: 700,
              mb: 2,
              color: "text.primary",
              fontSize: "32px",
            }}
          >
            Our Business Buying & Selling Approach
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: "center",
              maxWidth: "700px",
              mx: "auto",
              mb: 6,
              color: "text.secondary",
            }}
          >
            A structured approach to ensure successful business transactions
          </Typography>

          <Grid container spacing={4}>
            {processSteps.map((step, index) => (
              <Grid item xs={12} md={3} key={index}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <Card
                    sx={{
                      height: "100%",
                      p: 3,
                      backgroundColor: "background.paper",
                      borderRadius: "12px",
                      boxShadow: "none",
                      border: "1px solid rgba(0,0,0,0.05)",
                    }}
                  >
                    <Box
                      sx={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "50%",
                        bgcolor: "#E8F5E9",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 3,
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 700,
                          color: "#2DBA70",
                        }}
                      >
                        {index + 1}
                      </Typography>
                    </Box>
                    <Typography
                      variant="h5"
                      component="h3"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        fontSize: "20px",
                      }}
                    >
                      {step.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "text.secondary",
                      }}
                    >
                      {step.description}
                    </Typography>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Features Section */}
      <Container sx={{ py: 8 }}>
        <Typography
          variant="h4"
          component="h2"
          sx={{
            textAlign: "center",
            fontWeight: 700,
            mb: 2,
            color: "text.primary",
            fontSize: "32px",
          }}
        >
          Why Choose AQT Direct
        </Typography>
        <Typography
          variant="body1"
          sx={{
            textAlign: "center",
            maxWidth: "700px",
            mx: "auto",
            mb: 6,
            color: "text.secondary",
          }}
        >
          We provide comprehensive solutions tailored to your business
          transaction needs
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {features.map((feature, index) => (
            <Grid item xs={12} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <Card
                  sx={{
                    height: "100%",
                    p: 3,
                    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(0,0,0,0.05)",
                    borderRadius: "12px",
                    transition: "transform 0.3s, box-shadow 0.3s",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 12px 28px rgba(0,0,0,0.12)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mb: 3,
                    }}
                  >
                    {feature.icon}
                  </Box>
                  <Typography
                    variant="h5"
                    component="h3"
                    sx={{
                      textAlign: "center",
                      fontWeight: 600,
                      mb: 2,
                      fontSize: "20px",
                    }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      textAlign: "center",
                      color: "text.secondary",
                    }}
                  >
                    {feature.description}
                  </Typography>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* CTA Section */}
      {/* <Container sx={{ py: 8 }}>
        <Card
          sx={{
            p: 6,
            borderRadius: "12px",
            backgroundColor: "#2DBA70",
            color: "white",
            textAlign: "center",
            boxShadow: "0 8px 24px rgba(45, 186, 112, 0.3)",
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontWeight: 700,
              mb: 3,
              fontSize: "32px",
            }}
          >
            Ready to Buy or Sell Your Business?
          </Typography>
          <Typography
            variant="h5"
            sx={{
              mb: 4,
              maxWidth: "700px",
              mx: "auto",
              fontSize: "16px",
            }}
          >
            Let our experts guide you through a seamless transaction process
          </Typography>
        
        </Card>
      </Container> */}

      {/* CTA and Form */}
      <Container sx={{ py: 8 }}>
      <Grid container spacing={4} style={{ position: "relative", zIndex: 2 }}>
        {/* Left Section */}
        <Grid item xs={12} md={6} sx={{display:'flex', justifyContent:'center'}}>
          <Box className="left-section" >
            <Card
              sx={{
                p: 6,
                borderRadius: "12px",
                backgroundColor: "#2DBA70",
                color: "white",
                textAlign: "center",
                boxShadow: "0 8px 24px rgba(45, 186, 112, 0.3)",
            
              }}
            >
              <Typography
                variant="h4"
                component="h2"
                sx={{
                  fontWeight: 700,
                  mb: 3,
                  fontSize: "32px",
                }}
              >
                Ready to Buy or Sell Your Business?
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  mb: 4,
                  maxWidth: "700px",
                  mx: "auto",
                  fontSize: "16px",
                }}
              >
                Let our experts guide you through a seamless transaction process
              </Typography>
              {/* <Button
            variant="contained"
            size="large"
            sx={{
              bgcolor: 'white',
              color: '#2DBA70',
              px: 6,
              py: 2,
              fontSize: '1.1rem',
              '&:hover': { bgcolor: '#f5f5f5' }
            }}
          >
            Contact Us Today
          </Button> */}
            </Card>
          </Box>
        </Grid>

        {/* Right Section (Form Section) */}
        <Grid item xs={12} md={6}>
          <Box
            className="form-container"
            style={{
              padding: "20px",
              borderRadius: "15px",
              boxShadow: "0 8px 15px rgba(0, 0, 0, 0.15)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "@media (max-width: 768px)": {
                padding: "15px", // Reduce padding for mobile
              },
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "scale(1.02)")
            }
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            <form method="post" action="#" onSubmit={handleFormSubmit}>
              <Grid container spacing={3}>
                {/* Full Name & Mobile Number in One Row */}
                <Grid item xs={12}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="First Name"
                        name="firstName"
                        required
                        variant="outlined"
                        size="small"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "5px",
                        }}
                        sx={{
                          backgroundColor: "#ffffff",
                          borderRadius: "5px",
                          "& fieldset": {
                            border: "none", // Removes the default border
                          },
                          "& .MuiOutlinedInput-root": {
                            borderBottom: "2px solid #ccc", // Adds only a bottom border
                            "&:hover": {
                              borderBottom: "2px solid #0b837a", // Optional: Hover effect
                            },
                            "&.Mui-focused": {
                              borderBottom: "2px solid #0b837a", // Optional: Focus effect
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Last Name"
                        name="lastName"
                        required
                        variant="outlined"
                        size="small"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "5px",
                        }}
                        sx={{
                          backgroundColor: "#ffffff",
                          borderRadius: "5px",
                          "& fieldset": {
                            border: "none", // Removes the default border
                          },
                          "& .MuiOutlinedInput-root": {
                            borderBottom: "2px solid #ccc", // Adds only a bottom border
                            "&:hover": {
                              borderBottom: "2px solid #0b837a", // Optional: Hover effect
                            },
                            "&.Mui-focused": {
                              borderBottom: "2px solid #0b837a", // Optional: Focus effect
                            },
                          },
                        }}
                      />
                    </Grid>
                
                  </Grid>
                </Grid>

                {/* Email Address & Company Name in One Row */}
                <Grid item xs={12}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={6}>
                  
                      <TextField
                        fullWidth
                        label="Email Address"
                        type="email"
                        name="email"
                        required
                        variant="outlined"
                        size="small"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "5px",
                        }}
                        sx={{
                          backgroundColor: "#ffffff",
                          borderRadius: "5px",
                          "& fieldset": {
                            border: "none", // Removes the default border
                          },
                          "& .MuiOutlinedInput-root": {
                            borderBottom: "2px solid #ccc", // Adds only a bottom border
                            "&:hover": {
                              borderBottom: "2px solid #0b837a", // Optional: Hover effect
                            },
                            "&.Mui-focused": {
                              borderBottom: "2px solid #0b837a", // Optional: Focus effect
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Your Mobile Number"
                        type="tel"
                        name="phone"
                        required
                        variant="outlined"
                        size="small"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "5px",
                        }}
                        sx={{
                          backgroundColor: "#ffffff",
                          borderRadius: "5px",
                          "& fieldset": {
                            border: "none", // Removes the default border
                          },
                          "& .MuiOutlinedInput-root": {
                            borderBottom: "2px solid #ccc", // Adds only a bottom border
                            "&:hover": {
                              borderBottom: "2px solid #0b837a", // Optional: Hover effect
                            },
                            "&.Mui-focused": {
                              borderBottom: "2px solid #0b837a", // Optional: Focus effect
                            },
                          },
                        }}
                      />
                    </Grid>
                    
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Business Name"
                        type="text"
                        name="businessName"
                        required
                        variant="outlined"
                        size="small"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "5px",
                        }}
                        sx={{
                          backgroundColor: "#ffffff",
                          borderRadius: "5px",
                          "& fieldset": {
                            border: "none", // Removes the default border
                          },
                          "& .MuiOutlinedInput-root": {
                            borderBottom: "2px solid #ccc", // Adds only a bottom border
                            "&:hover": {
                              borderBottom: "2px solid #0b837a", // Optional: Hover effect
                            },
                            "&.Mui-focused": {
                              borderBottom: "2px solid #0b837a", // Optional: Focus effect
                            },
                          },
                        }}
                      />
                    </Grid>

                {/* Funding Requirements (Standalone Row) */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Description"
                    name="description"
                    required
                    multiline
                    rows={1}
                    variant="outlined"
                    size="small"
                    style={{
                      backgroundColor: "#ffffff",
                      borderRadius: "5px",
                    }}
                    sx={{
                      backgroundColor: "#ffffff",
                      borderRadius: "5px",
                      "& fieldset": {
                        border: "none", // Removes the default border
                      },
                      "& .MuiOutlinedInput-root": {
                        borderBottom: "2px solid #ccc", // Adds only a bottom border
                        "&:hover": {
                          borderBottom: "2px solid #0b837a", // Optional: Hover effect
                        },
                        "&.Mui-focused": {
                          borderBottom: "2px solid #0b837a", // Optional: Focus effect
                        },
                      },
                    }}
                  />
                </Grid>

                {/* Submit Button */}
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    style={{
                      background: "linear-gradient(90deg, #0b837a, #9ddad5)",
                      color: "#fff",
                      padding: "10px 20px",
                      fontWeight: "bold",
                      borderRadius: "25px",
                      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                      transition: "transform 0.3s ease",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(1.05)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                    fullWidth
                  >
                    SUBMIT
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Grid>
      </Grid>
      </Container>

      <Footer />
    </>
  );
}
